export class Reservation {
  adultos: number=0;
  menores: number=0;
  bebes: number=0;
  asientos: string='';
  doble: number=0;
  individual: number=0;
  triple: number=0;
  cuadruple: number=0;
  twin: number=0;
  matrimonial: number=0;
  // codigo: string;
  // estado: number;
  // fecha_registro:string;
  comprobante: string;
  user: number;
  paquete: number;
  id:number = 0;
}
